import {Pipe, PipeTransform} from '@angular/core';
import {Role} from 'src/app/core/model/role';

@Pipe({
  name: 'getRoleFromMap',
  standalone: true,
})
export class GetRoleFromMapPipe implements PipeTransform {
  transform(role: string, rolesMap: Record<string, Role>): Role {
    if (!role) return null;
    if (!rolesMap[role]) return null;

    return rolesMap[role];
  }
}
